import { useAuthStore } from '@/src/shared/lib/store/auth-store';
import { ActorType } from '@hummii/shared-types';

/**
 * Hook for working with Actor/Persona architecture
 *
 * ⚠️ Migration from UserRole to ActorType:
 * - CONTRACTOR → WORKER
 * - CLIENT → CLIENT
 * - ADMIN → user.isAdmin flag
 */
export function useRole() {
  const { user, activeActor, availableActors = [] } = useAuthStore();

  const activeActorType = activeActor?.type ?? null;

  // Helper booleans for active actor type
  const isActiveWorker = activeActorType === ActorType.WORKER;
  const isActiveClient = activeActorType === ActorType.CLIENT;
  const isActiveSupport = activeActorType === ActorType.SUPPORT;
  const isActiveStore = activeActorType === ActorType.STORE;
  const isAdmin = user?.isAdmin ?? false;

  // Check if user has multiple actors (personas)
  const hasMultipleActors = availableActors.length > 1;

  return {
    // Active actor
    activeActor,
    activeActorType,

    // Available actors
    availableActors,
    hasMultipleActors,

    // Helper booleans
    isActiveWorker,
    isActiveClient,
    isActiveSupport,
    isActiveStore,
    isAdmin,

    // Backward compatibility (deprecated)
    /** @deprecated Use activeActorType instead */
    activeRole: activeActorType,
    /** @deprecated Use isActiveWorker instead */
    isActiveContractor: isActiveWorker,
    /** @deprecated Use hasMultipleActors instead */
    hasMultipleRoles: hasMultipleActors,
    /** @deprecated Use availableActors instead */
    availableRoles: availableActors.map((actor) => actor.type),
  };
}
